import BopsAddress from './BopsAddress.container';

export default BopsAddress;
